import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CK_EDITOR_CONFIG } from '../constants';

@Component({
  selector: 'piqet-angular-ckeditor',
  templateUrl: './ckeditor.component.html',
  styleUrls: ['./ckeditor.component.scss'],
})
export class CkeditorComponent {
  ckEditorConfig = CK_EDITOR_CONFIG;
  @Input() label!: string;
  @Input() value!: string;

  @Output() valueChange = new EventEmitter<string>();

  onInput(event: any) {
    this.valueChange.emit(this.value);
  }
}
